<div class="w-full h-[94vh] flex flex-col items-center justify-center screen-alert-wrapper">
  <div class="w-[60%]">
    <app-image [url]="'/assets/images/png/large-screen-icon.png'"></app-image>
  </div>
  <div class="screen-alert-content font-poppins font-bold">
    This item works best on a large screen
  </div>
  <div class="w-full justify-center items-center flex hyper-link-wrapper">
    <span (click)="backToResourceList()"
          class="hyper-link-content">{{hyperLinkText}}</span>
  </div>
</div>
